import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["player", "agenda", "card"]

  connect() {
    if (this.cardTargets.length === 0) return

    const card = this.cardTargets[Math.floor(Math.random() * this.cardTargets.length)]
    this.agendaTarget.scrollTo({
      left: this.agendaTarget.scrollLeft + card.getBoundingClientRect().left - this.agendaTarget.getBoundingClientRect().left,
      behavior: "instant"
    })
    this.playerTarget.src = card.dataset.playerUrl
  }

  select(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    if (event.currentTarget.getAttribute("aria-current") === "true") return

    this.playerTarget.src = event.currentTarget.dataset.playerUrl
  }

  loaded() {
    const id = this.playerTarget.querySelector("media-player").dataset.recordingId
    const current = this.cardTargets.find(card => card.dataset.recordingId === id)

    for (const card of this.cardTargets) {
      const selected = card === current
      card.setAttribute("aria-current", String(selected))
      card.querySelector("[data-recording-status]").textContent = selected ? "Now playing" : "Watch recording"
    }
  }

  stop() {
    this.playerTarget.removeAttribute("src")
    this.playerTarget.replaceChildren()
    for (const card of this.cardTargets) {
      card.removeAttribute("aria-current")
      card.querySelector("[data-recording-status]").textContent = "Watch recording"
    }
  }
}
